<style src="./FormFileInput.scss" lang="scss" scoped></style>
<template>
  <section class="form-file-input">
    <div
      class="drop-zone"
      @dragover="isDragOver"
      @dragenter="isDragOver"
      @dragleave="isDragLeave"
      @dragend="isDragLeave"
      @drop="isDrop"
      :class="{'drop-zone-over': dragOverClass}">

      <label class="input-label">
        <input type="file" class="input-file" @change="inputFileOpen">
        <h2>Arraste o arquivo aqui ou clique para escolher</h2>
        <icon-upload class="icon" />
      </label>
    </div>
  </section>
</template>

<script>
import { IconUpload } from '@/components/primitives/icons'
import FileHandle from './FileHandle'

export default {
  name: 'FormFileInput',
  components: {
    IconUpload
  },
  data () {
    return {
      dragOverClass: false
    }
  },
  methods: {
    isDragOver (e) {
      e.preventDefault()
      e.stopPropagation()

      if (!this.dragOverClass) this.dragOverClass = true
    },
    isDragLeave (e) {
      e.preventDefault()
      e.stopPropagation()

      if (this.dragOverClass) this.dragOverClass = false
    },
    isDrop (e) {
      e.preventDefault()
      e.stopPropagation()
      this.readFile(e.dataTransfer.files[0])
    },
    readFile (pFile) {
      FileHandle(pFile)
        .then((result) => {
          this.$toasted.success('Itens importados com sucesso')
          this.$emit('refresh-list', true)
        })
    },
    inputFileOpen (pFile) {
      this.readFile(pFile.target.files[0])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event/components/new-event/form-file-input/FormFileInput.vue